module.controller('sampleDetailCreateCtrl', ['$q', '$rootScope', '$state',
		'planSamplingService', 'alertService', 'ASEBIOL_CONSTANTS',
		sampleDetailCreateCtrlFn ]);

function sampleDetailCreateCtrlFn($q, $rootScope, $state, planSamplingService,
		alertService, ASEBIOL_CONSTANTS) {
	var vm = this;
	vm.operationType = $state.current.data.type;

	vm.idPlanSampling = $state.params.idPlan;
	vm.idSampling = $state.params.idSampling;
	vm.product = {
		id : $state.params.idProduct
	}

	vm.sample = {};
	vm.samplingAnalysisSelected = [];
	vm.samplingAnalysisInit = [];
	
	vm.showBottomDown = true;

	vm.loading = false;

	vm.DATE_FORMAT = ASEBIOL_CONSTANTS.DATE_FORMAT;

	vm.options = {
		minDate : new Date(),
	};

	init();

	function init() {
		vm.loading = true;

		planSamplingService.getSamplingAnalysisList(vm.idPlanSampling,
				vm.idSampling).then(function(response) {
			vm.loading = false;
			var responseData = response.getData();
			var elements = responseData.map(function(e) {
				var map = {};
				map = e.technique;
				map.idSamplingAnalysis = e.id;
				map.dilutionExpected = e.dilutionExpected;
				map.observations = e.observations;
				map.analysis = e.analysis;
				map.analysis.regulation = e.regulation;
				return map;
			});
			vm.samplingAnalysisInit = elements;
		}, function(response) {
			vm.loading = false;
		});
	}

	vm.onSamplingAnalysisChange = function(samplingAnalysis, typeOperation) {
		var deferred = $q.defer();
		deferred.resolve('c');
		return deferred.promise;
	}

	vm.sendAction = function() {
		alertService.showSwtQuestion('Adicionar muestra al muestreo', create);
	};

	function create() {
		vm.loading = true;

		var createModel = {
			sampleAnalysis : []
		};

		if (vm.sample.observations)
			createModel.observations = vm.sample.observations;

		createModel.scheduleDate = moment(vm.sample.scheduleDate).format(
				ASEBIOL_CONSTANTS.DATETIME_FORMAT_MOMENT);

		vm.samplingAnalysisSelected.forEach(function(sa) {
			var item = {
				idRegulation : sa.analysis.regulation.id,
				idAnalysis : sa.analysis.id,
				idTechnique : sa.id,
				observationsAnalysis : sa.observations,
				dilutionExpected : sa.dilutionExpected
			};
			createModel.sampleAnalysis.push(item);
		});

		planSamplingService.addSample(vm.idPlanSampling, vm.idSampling,
				createModel).then(function(response) {
			vm.loading = false;
			alertService.showSuccess('Muestra adicionada satisfactoriamente');
			$state.go('home.samplingHome', {
				idPlan : vm.idPlanSampling,
				idSampling : vm.idSampling
			});
		}, function(response) {
			vm.loading = false;
		});
	}

};